import { WASTE_EXCHANGE_TYPE } from "../../../domain/WasteExchangeType";

/**
 * Próbuje dopasować pobrane kwity wagowe do wasteExchanges na podstawie kodu odpadu.
 * Działa tylko dla prostych przypadków:
 *  - 1 ticket + 1 exchange (każdy z 1 towarem)
 *  - N ticketów + N exchanges (każdy z 1 towarem), parowanie po zgodności kodu
 */
export function matchTicketsToExchanges(tickets, wasteExchanges) {
  if (!wasteExchanges || wasteExchanges.length === 0) {
    return tickets;
  }

  // Prosta heurystyka: próbujemy parować 1:1 gdy liczba ticketów = liczba exchanges,
  // a każdy ticket ma dokładnie 1 towar (kod odpadu). Exchange może mieć dowolną liczbę towarów.
  const isSimpleCase =
    tickets.length === wasteExchanges.length &&
    tickets.every((t) => t.externalData.wastes.length === 1);

  if (!isSimpleCase) return tickets;

  // Zbieramy dostępne exchanges (każdy może być użyty tylko raz)
  const available = [...wasteExchanges];

  return tickets.map((ticket) => {
    const ticketWasteCode = ticket.externalData.wastes[0]?.wasteCode; // np. "15 01 01"
    const matchIndex = available.findIndex(
      (exchange) => exchange.wastes.some((w) => w.code === ticketWasteCode)
    );
    if (matchIndex === -1) return ticket;

    const exchange = available[matchIndex];
    available.splice(matchIndex, 1);

    const exchangeType = exchange.isContainer
      ? WASTE_EXCHANGE_TYPE.CONTAINER_EXCHANGE
      : WASTE_EXCHANGE_TYPE.LOADING;

    const usedContainer =
      exchangeType === WASTE_EXCHANGE_TYPE.CONTAINER_EXCHANGE
        ? {
            usedContainerId: exchange.usedContainerId,
            groupContainerType: exchange.containerName,
          }
        : null;

    // Dla każdego towaru z exchange szukamy masy z kwitu na podstawie kodu odpadu.
    // Jeśli na kwicie jest dokładnie jeden towar o danym kodzie - używamy jego masy.
    // Jeśli nie ma żadnego lub jest ich więcej niż jeden - wasteMass = null.
    const updatedWastes = exchange.wastes.map((waste) => {
      const matchingTicketWastes = ticket.externalData.wastes.filter(
        (w) => w.wasteCode === waste.code
      );

      const wasteMass =
        matchingTicketWastes.length === 1
          ? (matchingTicketWastes[0].weightNet / 1000).toFixed(4)
          : 0.0000;

      return {
        ...waste,
        wasteId: waste.wasteId,
        wasteFormType: waste.wasteFormType,
        displayDescription: waste.displayDescription,
        wasteKindId: waste.wasteKindId,
        wasteKindName: waste.wasteKindName,
        wasteEntityId: waste.wasteKindId ?? waste.wasteId,
        wasteMass
      };
    });

    return {
      ...ticket,
      exchangeType,
      usedContainer,
      wastes: updatedWastes,
    };
  });
}
